import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalService } from 'ui-components/services/modal-service';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { UpsLabelTermsModal } from '../components/modals/ups-label-terms-modal';
import { messages } from '../components/modals/ups-label-terms-modal/messages';
import Global from '../store/global-selectors';
import { HAS_ACCEPTED_UPS_LABEL_TERMS_SETTING } from '../wallet/utilities/constants';

/**
 * Check if user has already accepted UPS label terms
 * @param {object} state - Redux state
 * @returns {boolean} - True if terms have been accepted
 */
export const hasUserAcceptedUpsLabelTerms = (state) => {
  const hasAcceptedSetting = Global.selectSellerSellerSetting(state, { settingName: HAS_ACCEPTED_UPS_LABEL_TERMS_SETTING });
  return hasAcceptedSetting === 'true';
};

const showDeclinedNotification = () => {
  NotificationService.showNotification({
    title: <FormattedMessage {...messages.cannotCreateLabelTitle} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
    content: <FormattedMessage {...messages.termsRequiredBody} />,
  });
};

/**
 * Launch the UPS label terms modal
 * @param {() => void} onAcceptTerms - Callback when terms are accepted
 * @param {() => void} [onDeclinedTerms] - Callback when terms are declined
 * @returns {string} - The modal ID (can be used to close the modal programmatically)
 */
export const launchUpsLabelTermsModal = (onAcceptTerms, onDeclinedTerms) => {
  return ModalService.launchModal({
    component: UpsLabelTermsModal,
    props: {
      onAccept: onAcceptTerms,
    },
    onClose: (isCancel) => {
      if (isCancel) {
        showDeclinedNotification();
        onDeclinedTerms?.();
      }
    },
  });
};
